module.exports = __webpack_public_path__ + "img/hotel_thumbnail-600x450.0a11fc67.jpg";